import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useSiteBranding from '../hooks/useSiteBranding';
import TrustSupportBanner from '../components/TrustSupportBanner';
import './TrustPages.css';

export default function PrivacyPolicyPage() {
  const { siteName } = useSiteBranding();
  const brand = siteName || 'Super Wear';

  useEffect(() => {
    document.title = `Privacy Policy — ${brand}`;
  }, [brand]);

  return (
    <div className="trust-page">
      <div className="trust-page__inner">
        <header className="trust-page__hero">
          <p className="trust-page__hero-eyebrow">Your data</p>
          <h1 className="trust-page__title">Privacy Policy</h1>
          <p className="trust-page__subtitle">
            How {brand} collects, uses, and protects your information.
          </p>
        </header>

        <TrustSupportBanner />

        <section className="trust-section">
          <h2>Information we collect</h2>
          <p>When you shop or create an account, we may collect:</p>
          <ul>
            <li>
              <strong>Name</strong> — to identify your orders and account.
            </li>
            <li>
              <strong>Phone number</strong> — for order updates, delivery coordination, and support.
            </li>
            <li>
              <strong>Shipping / billing address</strong> — to deliver your purchases and process payments where required.
            </li>
            <li>
              <strong>Email address</strong> — for confirmations, receipts, and optional marketing (if you opt in).
            </li>
            <li>
              Technical data such as device type and basic usage may be used to keep the site secure and improve
              performance.
            </li>
          </ul>
        </section>

        <section className="trust-section">
          <h2>How we use your data</h2>
          <ul>
            <li>
              <strong>Order processing</strong> — fulfilling purchases, payments, delivery, and returns.
            </li>
            <li>
              <strong>Communication</strong> — responding to questions and sending service-related messages (support
              available <strong>24/7</strong>).
            </li>
            <li>
              <strong>Fraud prevention &amp; security</strong> — protecting you and {brand} from misuse.
            </li>
          </ul>
        </section>

        <section className="trust-section">
          <h2>Data protection</h2>
          <p>
            We use reasonable technical and organizational measures to protect your personal data. Access is limited to
            people and systems that need it to run the store and support you.
          </p>
        </section>

        <section className="trust-section">
          <h2>Sharing with third parties</h2>
          <p>
            We do <strong>not</strong> sell your personal data. We only share information with trusted partners when
            needed to operate the service — for example <strong>payment processors</strong>, <strong>couriers</strong>,
            or <strong>hosting / email providers</strong> — and only to the extent required for your order or legal
            compliance.
          </p>
        </section>

        <section className="trust-section">
          <h2>Your choices</h2>
          <p>
            You may request corrections or ask questions about your data by contacting us via the{' '}
            <Link to="/contact">Contact</Link> page.
          </p>
        </section>

        <section className="trust-section">
          <h2>Updates</h2>
          <p>
            We may update this policy from time to time. The &quot;last updated&quot; intent is reflected on this page;
            continued use of the site after changes means you accept the revised policy.
          </p>
        </section>
      </div>
    </div>
  );
}
